/**
 * Adapter pour user_inventory
 * Utilise exclusivement Supabase
 */

import { UserGamificationInventoryItem } from '@/types/gamificationProducts';
import * as supabaseService from './userInventorySupabase';

export const getUserInventory = (userId: string): Promise<UserGamificationInventoryItem[]> => {
  return supabaseService.getUserInventory(userId);
};

export const addToInventory = (
  userId: string,
  productTemplateId: string,
  organizationId: string,
  quantity: number = 1,
  purchasePrice: number,
  source: UserGamificationInventoryItem['source'] = 'shop'
): Promise<UserGamificationInventoryItem> => {
  return supabaseService.addToInventory(userId, productTemplateId, organizationId, quantity, purchasePrice, source);
};

export const consumeItem = (itemId: string): Promise<UserGamificationInventoryItem | null> => {
  return supabaseService.consumeItem(itemId);
};

export const activateItem = (itemId: string, expiresAt?: string): Promise<UserGamificationInventoryItem | null> => {
  return supabaseService.activateItem(itemId, expiresAt);
};

export const getItemById = (itemId: string): Promise<UserGamificationInventoryItem | null> => {
  return supabaseService.getItemById(itemId);
};

export const getAvailableItemsByTemplate = (
  userId: string,
  productTemplateId: string
): Promise<UserGamificationInventoryItem[]> => {
  return supabaseService.getAvailableItemsByTemplate(userId, productTemplateId);
};

export const getItemCount = (userId: string, productTemplateId: string): Promise<number> => {
  return supabaseService.getItemCount(userId, productTemplateId);
};

export const removeFromInventory = (itemId: string): Promise<boolean> => {
  return supabaseService.removeFromInventory(itemId);
};

export const bulkAddToInventory = async (
  userId: string,
  items: Array<{
    productTemplateId: string;
    organizationId: string;
    quantity: number;
    purchasePrice: number;
    source?: UserGamificationInventoryItem['source'];
  }>
): Promise<UserGamificationInventoryItem[]> => {
  // Add items one by one for now, optimize later if needed
  const results: UserGamificationInventoryItem[] = [];
  for (const item of items) {
    const result = await supabaseService.addToInventory(
      userId,
      item.productTemplateId,
      item.organizationId,
      item.quantity,
      item.purchasePrice,
      item.source || 'shop'
    );
    results.push(result);
  }
  return results;
};

export const markItemAsActive = async (itemId: string): Promise<boolean> => {
  const result = await supabaseService.activateItem(itemId);
  return result !== null;
};

export const markItemAsInactive = async (itemId: string): Promise<boolean> => {
  return supabaseService.markItemAsInactive(itemId);
};

// Nouvelles fonctions pour le système de gels par quantité
export const consumeOneFromItem = supabaseService.consumeOneFromItem;
export const getTotalGelCount = supabaseService.getTotalGelCount;
export const getAvailableGelItems = supabaseService.getAvailableGelItems;

// Re-export du type
export type { ConsumeOneResult } from './userInventorySupabase';

